import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms31e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms31e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    sendParams = {
      p_dteduest: (typeof searchParams.dtestrt !== 'undefined' ? searchParams.dtestrt.replace(/\//g, '') : ''),
      p_dtedueen: (typeof searchParams.dteend !== 'undefined' ? searchParams.dteend.replace(/\//g, '') : ''),
      p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
      p_codempid_query: (typeof searchParams.codempstapp !== 'undefined' ? searchParams.codempstapp : '')
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hrms31e/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid_query + '/' + searchParams.p_dteduepr.replace(/\//g, '') + '/' + searchParams.p_numseq + '/' + searchParams.p_dtest.replace(/\//g, '')
    return instance().get(endpoint + '/hrms31e/detail/' + params)
    // let sendParams = {}
    // sendParams = {
    //   p_dtest: searchParams.p_dtest.replace(/\//g, '')
    // }
    // let params = searchParams.p_codempid_query + '/' + searchParams.p_dteduepr.replace(/\//g, '') + '/' + searchParams.p_numseq
    // if (isMock) return generator(mocker.detail())
    // return instance().get(endpoint + '/hrms31e/detail/' + params, { params: sendParams })
  },
  getDetailSearch (searchParams) {
    if (isMock) return generator(mocker.detailTab3Search())
    const params = searchParams.p_codempid_query + '/' + searchParams.p_dtest.replace(/\//g, '') + '/' + searchParams.p_dteed.replace(/\//g, '')
    return instance().get(endpoint + '/hrms31e/updateSearch/' + params)
  },
  getDetailPopup (popupParams) {
    let searchParams = {
      p_codempid: popupParams.p_codempid,
      // p_dteeffec: popupParams.p_dteeffec,
      p_numseq: popupParams.p_numseq,
      p_typproba: popupParams.p_typproba
    }
    if (isMock) return generator(mocker.popupDetail())
    const params = searchParams.p_codempid + '/' + searchParams.p_numseq + '/' + searchParams.p_typproba
    return instance().get(endpoint + '/hrms31e/detailPopup/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hrms31e/dropdowns')
  },
  postSave ({ indexSelected, detail, codeval }) {
    let sendParams = {
      param_json: JSON.stringify({
        tab1: {
          typproba: detail.tab1.typproba,
          qtyasg: detail.tab1.qtyasg,
          qtyapp: detail.tab1.qtyapp,
          dteempmt: detail.tab1.dteempmt,
          dteduepr: detail.tab1.dteduepr,
          dteeval: detail.tab1.dteeval,
          scorepr: detail.tab1.scorepr.toString().replace(/,/g, ''),
          codrespr: detail.tab1.codrespr,
          qtyexpand: detail.tab1.qtyexpand.replace(/,/g, ''),
          desnote: detail.tab1.desnote,
          codexemp: detail.tab1.codexemp,
          desc_codexemp: detail.tab1.desc_codexemp,
          flgappr: detail.tab1.flgappr,
          codcomp: indexSelected.codcomp,
          codpos: indexSelected.codpos,
          p_codempid_query: indexSelected.codempid,
          p_numseq: indexSelected.numseq,
          p_codeval: codeval
        },
        tab2: detail.tab2
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms31e/save', sendParams)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hrms31e/cancel', cancelParams)
  },
  postDelete (deleteParams) {
    if (isMock) return generator(mocker.delete())
    let params = deleteParams.p_codempid_query + '/' + deleteParams.p_dteduepr.replace(/\//g, '') + '/' + deleteParams.p_numseq
    return instance().post(endpoint + '/hrms31e/delete/' + params)
  },
  postSendMail (sendMailParams) {
    if (isMock) return generator(mocker.sendMail())
    let params = sendMailParams.p_codempid_query + '/' + sendMailParams.p_dteduepr.replace(/\//g, '') + '/' + sendMailParams.p_numseq
    return instance().post(endpoint + '/hrms31e/sendMail/' + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms31e/index.js